<template>
  <div class="Chambers">

    <div class="chamber-cols">
      <div v-for="chamber in chambers" :key="chamber.id" class="chamber-col">
        <Chamber :chamber="chamber"/>
      </div>
    </div>

  </div>
</template>

<script>

import Chamber from '@/components/Chamber.vue'

//import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Chambers',
  components: {
    Chamber
  },
  props: {
    chambers: Array,
    idTheme: Number
  },
  computed: {
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .Chambers{
  }

  .stickyTop{
    top: 40px;
  }

  .chamber-cols{
    overflow-x: auto;
    display: flex;
    justify-content: flex-start;
    flex: 1;
  }

  .chamber-col{
    flex: 1;
    min-width: 300px;
    padding: 10px;
  }

  .chamber-col:not(:last-child) {
    border-right: 1px solid lightgray;
  }

  .chamber-col:nth-child(even){
    background: rgb(220,220,220);
  }

  @media screen and (max-width: 600px) {

    .chamber-col{
      flex: 0 0 calc(100% - 40px);
      max-width: 100% !important;
    }
  }

  /*.chamber-cols > div:not(:last-child) {
    margin-right: 20px;
  }*/

</style>
